export default {
  getSalesProfitList: {
    url: '/order/getSalesProfitList',
    method: 'post',
    desc: '获取销售利润列表'
  },
  getSalesProfitTotal: {
    url: '/order/getSalesProfitTotal',
    method: 'post',
    desc: '获取销售利润总计'
  },
}
